const realisations = [
  // {
  //   annee: "2024",
  //   titre: "www.lattard.fr",
  //   resume: "Conception de mon portfolio professionel",
  //   detail: `Mon portfolio professionnel a été développé en parallèle avec l'avancement du bootcamp de développement web, 
  //           afin d'appliquer de manière concrète les différentes technologies couvertes.`,
  //   lien: 'https://github.com/Mlattard/Green_Trade',
  //   technos: [
  //     "HTML & CSS",
  //     "JavaScript",
  //     "React"
  //   ],
  //   imgPrincipale: "greentrade_principale.jpg",
  //   galerie : [
  //     {
  //       lien: "greentrade_nouveau_membre.png",
  //       legende: "Formulaire d'enregistrement d'un nouveau membre"
  //     },
  //     {
  //       lien: "greentrade_membre_accueil.png",
  //       legende: "Page d'accueil d'un membre"
  //     },
  //     {
  //       lien: "greentrade_membre_historique.png",
  //       legende: "Historique d'achat d'un membre"
  //     },
  //     {
  //       lien: "greentrade_admin_controle.png",
  //       legende: "Panneau de controle d'un administrateur"
  //     }
  //   ]
  // },
  {
    annee: "2024",
    titre: "colomberaby.com ",
    resume: "Portfolio professionnel",
    detail: `Développement du portfolio pour Colombe Raby, conceptrice visuelle dans le milieu du cinéma.`,
    lien: 'https://www.colomberaby.com',
    technos: [
      "HTML & CSS", 
      "JavaScript", 
      "Node",
      "React",   
    ],
    imgPrincipale: "ColombeRaby/CR1.jpg",
    galerie : [
      {
        lien: "ColombeRaby/CR1.jpg",
        legende: "Page d'accueil du site"
      },
      {
        lien: "ColombeRaby/CR2.jpg",
        legende: "Page présentant l'ensemble des productions"
      }
    ]
  },
  {
    annee: "2024",
    titre: "Bootcamp de développement web",
    resume: "Projets de synthèse par sections",
    detail: `Le Bootcamp complet de développement web développé par Angela Yu sur Udemy offre un parcours complet pour 
            devenir développeur web full-stack. Avec plus de 62 heures de tutoriels vidéo et de projets réels, il couvre de nombreux langages 
            dont HTML, CSS, JavaScript, Node.js ou React.js, notamment grâce à des cours animés, des défis de codage, des quiz et un 
            portefeuille de plus de 32 sites web à la fin du cours.`,
    lien: 'https://www.udemy.com/course/the-complete-web-development-bootcamp/?couponCode=24T5FS31824',
    technos: [
      "HTML & CSS", 
      "JavaScript", 
      "Node",
      "React",
      "PostreSQL"      
    ],
    imgPrincipale: "Bootcamp/bootcamp_principale.jpg",
    galerie : [
      {
        lien: "Bootcamp/EJS_capstone.png",
        legende: "Formulaire d'enregistrement d'un nouveau membre"
      },
      {
        lien: "Bootcamp/EJS_capstone2.png",
        legende: "Page d'accueil d'un membre"
      },
      {
        lien: "Bootcamp/FamTravelTracker.png",
        legende: "Historique d'achat d'un membre"
      },
      {
        lien: "Bootcamp/KeeperApp.png",
        legende: "Panneau de controle d'un administrateur"
      }
    ]
  },
  {
    annee: "2023",
    titre: "GreenTrade",
    resume: "Projet de plateforme de vente de produits de seconde-main",
    detail: `Le développement de GreenTrade, projet final de classe, avait pour but de mettre en pratique toutes les 
            compétences acquises au cours du programme. Le projet couvre plusieurs aspects liés au développement web : 
            le front-end avec la mise en forme du site et la création de visuels harmonieux, le back-end avec la gestion des routes
            d'un site multi-pages, la gestion de base de données et la communication avec le serveur. Dans un souci de clarté pour 
            l'architecture du projet, celui-ci est structuré en suivant le modèle MVC. `,
    lien: 'https://github.com/Mlattard/Green_Trade',
    technos: [
      "HTML & CSS", 
      "JavaScript", 
      "PHP",
      "jQuery",
      "MySQL"
    ],
    imgPrincipale: "GreenTrade/greentrade_principale.jpg",
    galerie : [
      {
        lien: "GreenTrade/greentrade_nouveau_membre.png",
        legende: "Formulaire d'enregistrement d'un nouveau membre"
      },
      {
        lien: "GreenTrade/greentrade_membre_accueil.png",
        legende: "Page d'accueil d'un membre"
      },
      {
        lien: "GreenTrade/greentrade_membre_historique.png",
        legende: "Historique d'achat d'un membre"
      },
      {
        lien: "GreenTrade/greentrade_admin_controle.png",
        legende: "Panneau de controle d'un administrateur"
      }
    ]
  }
];

export default realisations;